module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main"
  }, [_c('Icon', {
    attrs: {
      "size": "big",
      "type": _vm.status
    }
  }), _c('div', {
    staticClass: "main__wrapper"
  }, [_c('h3', {
    staticClass: "main__title"
  }, [_vm._v(_vm._s(_vm.title))]), (_vm.description.length) ? _c('Accordion', {
    attrs: {
      "opened": _vm.isOpened
    }
  }, [_c('p', {
    staticClass: "main__text"
  }, [_vm._v(_vm._s(_vm.description))])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c65c662","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/requestcard/components/main/MentoringMain.vue
// module id = 9c7a470fe8a647604e12
// module chunks = 89